<template>
  <path
    d="M20 2.00018H4.01001C2.91001 2.00018 2.01001 2.90018 2.01001 4.00018V22.0002L6.00001 18.0002H20C21.1 18.0002 22 17.1002 22 16.0002V4.00018C22 2.90018 21.1 2.00018 20 2.00018ZM13 14.0002H11V12.0002H13V14.0002ZM13 9.00018C13 9.55018 12.55 10.0002 12 10.0002C11.45 10.0002 11 9.55018 11 9.00018V7.00018C11 6.45018 11.45 6.00018 12 6.00018C12.55 6.00018 13 6.45018 13 7.00018V9.00018Z"
  />
</template>
